import { DisclaimerConfig } from "@ui/context/component-config-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const disclaimerConfig: RecursivePartial<DisclaimerConfig> = {
  disclaimerText:
    "If you buy something from a Verge link, Vox Media may earn a commission.",
  ethicsUrl: "https://www.theverge.com/ethics-statement",
  scorecardDisclaimerText: "How we rate and review products",
  scorecardDisclaimerUrl: "https://www.theverge.com/pages/how-we-rate",
};

export default disclaimerConfig;
